<ng-container>
  <div class="modal-body">
    <form [formGroup]="attorneyInformationForm" class="clrsgn-form">
      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="participantRole" class="filter-label">
              Participant Role
            </mat-label>
            @if ((isEditing$ | async)) {
              <input matInput formControlName="participantRole" [readonly]="true" />
            }
            @if (!(isEditing$ | async)) {
              <mat-select
                formControlName="participantRole"
                id="participantRole"
                data-cy="attorneyRoleDropdownList">
                <mat-option [value]="attorneyRole">
                  Attorney
                </mat-option>
              </mat-select>
            }
            <app-form-error [group]="attorneyInformationForm"
              [controlName]="'participantRole'"></app-form-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="existingAttorney" class="filter-label">
              Attorney
            </mat-label>
            <mat-select (selectionChange)="onAttorneyChanged($event.value)"
              (openedChange)="onAttorneyDropdownOpened($event, attorneySearchInput)"
              formControlName="existingAttorney"
              id="existingAttorney">
              <small class="text-muted ps-3">Search:</small>
              <input matInput #attorneySearchInput placeholder="Type at least 2 characters to search by name or email" class="ps-3 pt-2" (input)="onSearchInput($event)">
              @if (currentSearchTerm.length < minSearchLength) {
                <mat-option disabled>
                  <em class="text-muted">Type at least {{ minSearchLength }} characters to begin searching</em>
                </mat-option>
              } @else if (searchResults.length === 0) {
                <mat-option disabled>
                  <em class="text-muted">No accounts match "{{ currentSearchTerm }}"</em>
                </mat-option>
              } @else {
                <mat-option value="removeSelection">
                  Remove Selection
                </mat-option>
                @for (account of searchResults; track account.accountId) {
                  <mat-option
                    [value]="account">
                    {{ account.firstName }} {{ account.lastName }} ({{ account.emailAddress }})
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="emailAddress" class="filter-label">
              Email Address
            </mat-label>
            <input matInput
              maxlength="128"
              type="text"
              formControlName="emailAddress"
              id="emailAddress" />
            <app-form-error [group]="attorneyInformationForm"
              [controlName]="'emailAddress'"></app-form-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="firstName" class="filter-label">
              First Name
            </mat-label>
            <input matInput
              maxlength="200"
              type="text"
              formControlName="firstName"
              id="firstName" />
            <app-form-error [group]="attorneyInformationForm"
              [controlName]="'firstName'"></app-form-error>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="lastName" class="filter-label">
              Last Name
            </mat-label>
            <input matInput
              maxlength="200"
              type="text"
              formControlName="lastName"
              id="lastName" />
            <app-form-error [group]="attorneyInformationForm"
              [controlName]="'lastName'"></app-form-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button"
      class="btn-secondary"
      data-bs-dismiss="modal"
      (click)="resetModal('cancel')">
      Cancel
    </button>
    @if (isEditing$ | async) {
      <button
        type="button"
        class="btn-primary"
        (click)="updateParticipant()">
        Save Participant
      </button>
    }
    @if (!(isEditing$ | async)) {
      <button
        type="button"
        class="btn-primary"
        data-bs-dismiss="modal"
        (click)="addParticipant()">
        Add Participant
      </button>
    }
  </div>
</ng-container>
